export const BRAND = {
  name: "VISION ONE",
  tagline: "WEBDESIGN & MARKETING",
  logoMark: "/v1-mark.png",
  logoWordmark: "/v1-wordmark.png",
  heroImage:
    "https://customer-assets-v7afamib.emergentagent.net/job_video-hero-ui/artifacts/2mj5sink_ChatGPT%20Image%20Jul%2030%2C%202026%2C%2009_11_51%20AM.png",
};

export const NAV_LINKS = [
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Referenzen", href: "/#referenzen" },
  { label: "Preise", href: "/#preise" },
  { label: "Über uns", href: "/#ueber-uns" },
];
